/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-21 18:20:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-12-17 14:40:32
 */
import { aseDecode } from '@/js/utils'
export default {
    appName(state) { //appName
        return state.baseInfo.appName
    },
    version(state) { //version
        return state.baseInfo.version
    },
    companyName(state) { //companyName
        return state.baseInfo.companyName
    },
    organizationName(state) { //机构名称organizationName
        return state.baseInfo.organizationName
    },
    organizationNickName(state) { //机构名称organizationName
        return state.baseInfo.organizationNickName
    },
    organizationLogo(state) { //机构logo
        return state.baseInfo.organizationLogo
    },
    telephone(state) { //机构名称organizationName
        return state.baseInfo.telephone
    },
    viewTabs(state) { //tabs-view标签展示
        return state.viewTabs
    },
    themeColor(state) { ////主题颜色，默认 #409EFF
        return state.themeColor
    },
    isCollapse(state) { //是否收起菜单
        return state.menuRelated.isCollapse
    },
    collapseText(state) { //展开或收起时的title文案
        return state.menuRelated.collapseText
    },
    leftMenuWid(state) { //左侧菜单宽度
        return state.menuRelated.leftMenuWid
    },
    contentTableHei(state) { //内容区表格的高度
        return state.contentTableHei
    },
    pageSize(state) { //分页组件每页显示条目个数
        return state.pageSize
    },
    pageSizes(state) { //分页组件每页显示条目个数选择框
        let size = state.pageBaseSize
        return [size, size * 2, size * 3, size * 4, size * 5, size * 6, size * 7, size * 8, size * 9, size * 10]
    },
    rolePermission(state) { //角色权限
        return aseDecode(state.rolePermission, "AneuPlan-gygfuewifhertfeith56u489trf#%$&gvdfvjrty56&");
    },
    roleID(state) { //角色ID
        return Number(aseDecode(state.roleID, "AneuPlan-8847￥￥%ERF_)((^%4dkfj&45"));
    },
    // 能访问的bid
    tableIdArr(state){
        return JSON.parse(aseDecode(state.tableIdArr, "AneuPlan-8847￥￥%ERF_)((^%4dkfj&45"));
        // return state.tableIdArr
    },
}


// WEBPACK FOOTER //
// ./src/store/getters.js